let _worker = null
let _active = false

export const happeningNow = (timeEntry, millis) =>
  timeEntry + millis > Date.now()

export const wasToday = timeEntry => {
  const today = new Date()
  const midnight = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate(),
    0,
    0,
    0
  )
  return timeEntry - midnight.getTime() > 0
}

export const seconds = count => 1000 * count
export const minutes = count => 1000 * 60 * count
export const getMidnight = () => {
  const today = new Date()
  return new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate(),
    0,
    0,
    0
  ).getTime()
}

export const WorkerTimer = (interval, duration) => {
  const code = `
    let i=${duration / 1000}
    function timer() {
      if (i >= 0) {
        postMessage(i--)
        setTimeout(timer, ${interval})
      } else {
        close()
      }
    }
    timer()`
  const blob = new Blob([code], { type: 'application/javascript' })

  _worker = new Worker(URL.createObjectURL(blob))
}

export const timerStart = ({ interval, duration, intervalFn }) => {
  if (_active === true) {
    return new Promise((resolve, reject) =>
      reject(new Error('timer already active'))
    )
  }
  _active = true

  return new Promise(resolve => {
    WorkerTimer(interval, duration)
    if (typeof intervalFn === 'function') {
      _worker.onmessage = ({ data }) => {
        intervalFn(data)
        if (data === 0) {
          timerStop()
          resolve()
        }
      }
    }
  })
}

export const timerStop = () => {
  if (_active === false) {
    return
  }
  _worker && _worker.terminate && _worker.terminate()
  _worker = null
  _active = false
}

export const formatTime = seconds =>
  `${pad2(minutesPlace(seconds))}:${pad2(secondsPlace(seconds))}`

export const minutesPlace = seconds => Math.floor(seconds / 60)
export const secondsPlace = seconds => seconds % 60
export const pad2 = num => ('00' + num).slice(-2)



// WEBPACK FOOTER //
// ./src/utils/timer.js